// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"libs_client_admin_src_index_ts":"811fb95731d8e85c","libs_client_help-faq_src_index_ts":"7b17cbfa7c8e0739","apps_customer_westlotto_client_src_lib_content_content_component_ts":"4b95f2b1c0dafbb4"}[chunkId] + ".js";
};